/* Paths */

export const ARTICLES = "/v1/conceptsWithArticles";
export const GENERATE_PAYMENT = "/api/solicitud_pago/v1/checkout/solicitud_pago";
export const SAVE_PAYMENT = "/v1/payments";
export const getPathSummary = (id) => {
  return `/v1/payments/${id}/summary`;
};
export const getPathDetail = (intId) => {
  return `/v1/payments/${intId}/summary/pdf`;
};

/*Headers*/

export const HEADER_PAYMENT_REQUEST = {
  Authorization: "Bearer " + "8c4c5c64-8793-47b7-b959-c235784b6498",
  ContentType: "multipart/form-data",
};
